import { Modal, ModalProps } from "antd";
import classes from "./ModalSigningDocs.module.css";
import React from "react";

interface ModalSigningDocsProps extends ModalProps {
  titleProps?: React.HTMLAttributes<HTMLParagraphElement>;
}

export const ModalSigningDocs = ({
  mask = false,
  titleProps,
  children,
  title,
  footer = <></>,
  ...restProps
}: ModalSigningDocsProps) => {
  const concatTitleClassName = `${
    titleProps?.className ? titleProps.className : ""
  } ${classes.title}`;
  return (
    <Modal mask={mask} title={false} footer={footer} {...restProps}>
      <p className={concatTitleClassName}>{title}</p>

      {children}
    </Modal>
  );
};
